import { AlphaCard, Box, HorizontalGrid, HorizontalStack, Icon, Text, VerticalStack, useBreakpoints } from "@shopify/polaris";
import { numberToUSD } from "../../utils";
import { BehaviorMajor, BehaviorMinor, CashDollarMajor, ClockMajor, ImagesMajor, SmileyHappyMajor } from "@shopify/polaris-icons";

function StatCard({ title, value, icon }) {
  return (
    <AlphaCard>
      <VerticalStack gap="2" inlineAlign="start">
        <HorizontalStack>
          <Icon source={icon} color="subdued" />
        </HorizontalStack>
        <Text variant="bodyLg">{title}</Text>
        <Text variant="headingLg">{value}</Text>
      </VerticalStack>
    </AlphaCard>
  )
}

export default function Earnings({ summaryData, isAffiliate }) {

  return (
    <VerticalStack gap="5">
      <HorizontalGrid gap="3" columns={!isAffiliate ? "4" : { xs: "3", md: "5" }} alignItems="end">
        <StatCard title="Posts" value={summaryData?.totalContent || 0} icon={ImagesMajor} />
        <StatCard title="Engagements" value={summaryData?.orders || 0} icon={SmileyHappyMajor} />
        {
          isAffiliate ? (
            <>
              <StatCard title="Link Clicks" value={summaryData?.totalClicks || 0} icon={BehaviorMajor} />
            </>
          ) : null
        }
        <StatCard title="Earnings" value={numberToUSD(summaryData?.totalEarnings)} icon={CashDollarMajor} />
        <StatCard title="Unpaid" value={numberToUSD(summaryData?.unpaidEarnings)} icon={ClockMajor} />
      </HorizontalGrid>
    </VerticalStack>
  )
}
